import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  padding: 4px 4px 4px 9px;
`;

/**
 * Footer statico che contiene la versione dell'applicativo
 */
export function StaticFooter() {
  return (
    <StyledFooter>
      <span>v{process.env.VERSION}</span>
    </StyledFooter>
  );
}
